import { CancelledContractCompanyListPage } from "@/features/company/pages/CancelledContractCompanyList";
import React from "react";

const CancelledContractCompanyList = () => {
  return <CancelledContractCompanyListPage />;
};

export default CancelledContractCompanyList;
